module.exports = __webpack_public_path__ + "static/img/A2.85eb378e.jpg";